import { useMutation, useQueryClient } from 'react-query';
import { ToastContext } from 'app/components/Context/ToastContext';
import { useContext } from 'react';
import { CreateCommunityIdea } from 'services/apiServices';
import {
  TCreateIdeaResult,
  Errors,
  CreateIdeaParams,
} from 'types/ApiServicesTypes';

export default function useCreateCommunityIdea() {
  const { showAlert } = useContext(ToastContext);
  const queryClient = useQueryClient();

  const mutation = useMutation<TCreateIdeaResult, Errors, CreateIdeaParams>(
    ['CreateCommunityIdea'],
    values =>
      CreateCommunityIdea(values)
        .then(res => {
          showAlert!('Idea created successfully', 'success');
          // Invalidate and refetch ideas list
          void queryClient.invalidateQueries(['GetCommunityIdeas']);
          return res;
        })
        .catch(err => {
          showAlert!(err.message as string);
          return err;
        }),
  );

  if (mutation.isError && mutation.error) {
    showAlert!(mutation.error.message);
  }

  return mutation;
} 